import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import IconBase from '../IconBase';
import { jsxs as _jsxs } from "react/jsx-runtime";
export var createSvgIcon = function createSvgIcon(_ref) {
  var path = _ref.path,
      rect = _ref.rect,
      displayName = _ref.displayName,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 32 32' : _ref$viewBox;

  var Component = function Component(props, ref) {
    var paths = React.Children.toArray(path);
    var rects = React.Children.toArray(rect);
    return /*#__PURE__*/_jsxs(IconBase, _objectSpread(_objectSpread({
      "data-testid": "".concat(displayName, "Icon"),
      ref: ref,
      viewBox: viewBox
    }, props), {}, {
      children: [React.Children.map(paths, function (child) {
        return /*#__PURE__*/React.cloneElement(child, {
          fill: 'currentColor'
        });
      }), React.Children.map(rects, function (child) {
        return /*#__PURE__*/React.cloneElement(child, {
          fill: 'currentColor'
        });
      })]
    }));
  };

  var Wrapped = /*#__PURE__*/React.memo( /*#__PURE__*/React.forwardRef(Component));
  Wrapped.displayName = "".concat(displayName, "Icon");
  return Wrapped;
};
export default createSvgIcon;